const V2_WORKSPACES = `${import.meta.env.VITE_API_URL}/v2/workspaces`;
export const WORKSPACE_URL = (workspaceId?: string | number) => `${V2_WORKSPACES}/${workspaceId}`;
export const EVENT_RECORDS = (workspaceId?: string | number, eventId?: string | number) =>
  `${WORKSPACE_URL(workspaceId)}/events/${eventId}/message_records`;
export const SUMMARY_RECORDS = (workspaceId?: string | number, eventId?: string | number) =>
  `${WORKSPACE_URL(workspaceId)}/events/${eventId}/summary_records`;
